<template>
    <v-card>
        <v-card-title>
            Britishpedia Personalities
            <v-spacer></v-spacer>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
            :items="rows"
            :headers="headers"
            :items-per-page="10"
            :loading="loading"
            :search.sync="search"
            :footer-props="footerProps"
            :options.sync="options"
            :server-items-length="serverItemsLength"
            loading-text="Loading... Please wait"
        >
            <template v-slot:item.flag="{ item }">
                <country-flag country="sk" size="normal"></country-flag>
            </template>

            <template v-slot:item.contacts="{ item }">
                <span v-html="nextLine(item.contacts)"></span>
            </template>

            <template v-slot:item.companies="{ item }">
                <span v-html="nextLine(item.companies)"></span>
            </template>

        </v-data-table>
    </v-card>
</template>

<script>

import api from '../../_api'
import CountryFlag from 'vue-country-flag'

export default {

    name: 'personalities',
    components: {
        CountryFlag
    },

    data() {
        return {
            serverItemsLength: 0,
            awaitingSearch: false,
            pagination: {},
            options: {},
            search: '',
            loading: false,
            footerProps: {
                "items-per-page-options": [10, 20, 50, 100]
            },
            headers: [
                {
                    text: '',
                    align: 'start',
                    sortable: false,
                    value: 'flag',
                    width: 20
                },
                {
                    text: '#',
                    align: 'start',
                    sortable: true,
                    value: 'id',
                    width: 80,
                    cellClass: 'text--disabled text-caption'
                },
                {
                    text: 'Name',
                    align: 'start',
                    sortable: true,
                    value: 'str_Vorname',
                },
                {
                    text: 'Surname',
                    align: 'start',
                    sortable: true,
                    value: 'str_Nachname',
                },
                {
                    text: 'Private contacts',
                    align: 'start',
                    sortable: false,
                    value: 'contacts',
                    cellClass: 'text-caption'
                },
                {
                    text: 'Company contacts',
                    align: 'start',
                    sortable: false,
                    value: 'companies',
                    cellClass: 'text-caption'
                }
            ],
            rows: [],
        }
    },

    computed: {
        params() {
            return {...this.options, ...{'search': this.search}}
        }
    },

    watch: {
        options: {
            handler() {
                this.loadPage()
            },
            deep: true
        },
        search: {
            handler() {
                if (this.search.length ==0 || !this.awaitingSearch) {
                    setTimeout(() => {
                        this.loadPage();
                        this.awaitingSearch = false;
                    }, 1000)
                    this.awaitingSearch = true;
                }
            }
        }
    },

    methods: {
        loadPage() {
            this.loading = true
            this.rows = []
            api.loadPersonalities(this.params).then(response => {
                this.serverItemsLength = response.data.meta.total
                this.rows = response.data.data
            }).then(() => {
                this.loading = false
            })
        },

        nextLine(line) {
            return line.replaceAll("\n", "<br />");
        }
    },

    mounted() {

    }
}

</script>
